import { Box } from '@mui/material';

import { Shimmer } from './Shimmer';

interface FormSkeletonProps {
  /** Number of label + input pairs. */
  fields?: number;
  /** Section heading + description above the fields. */
  withHeader?: boolean;
  /** Trailing Cancel / Save button row. */
  withActions?: boolean;
}

/**
 * Placeholder for a form card (Add Admission / Add Installment while an existing
 * record loads, or a Settings card). Fields go 1-up on xs, 2-up from sm and 3-up
 * from md — matching the real forms' grid.
 */
export const FormSkeleton = ({ fields = 6, withHeader = true, withActions = true }: FormSkeletonProps) => (
  <Box
    sx={(theme) => ({
      bgcolor: 'white', border: `1px solid ${theme.palette.grey[200]}`, borderRadius: '16px',
      p: { xs: '16px', sm: '20px', md: '24px' },
      boxShadow: '0px 1px 3px rgba(0,0,0,0.06)',
      display: 'flex', flexDirection: 'column', gap: '20px',
    })}
  >
    {withHeader && (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
        <Shimmer height={16} width={{ xs: '55%', sm: 180 }} />
        <Shimmer height={12} width={{ xs: '80%', sm: 300 }} />
      </Box>
    )}

    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' },
        gap: '16px',
      }}
    >
      {Array.from({ length: fields }, (_, i) => (
        <Box key={i} sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <Shimmer height={11} width="42%" />
          <Shimmer height={40} radius="8px" />
        </Box>
      ))}
    </Box>

    {withActions && (
      <Box sx={{ display: 'flex', justifyContent: { xs: 'stretch', sm: 'flex-end' }, gap: '10px' }}>
        <Shimmer height={38} width={{ xs: '50%', sm: 100 }} radius="8px" />
        <Shimmer height={38} width={{ xs: '50%', sm: 130 }} radius="8px" />
      </Box>
    )}
  </Box>
);
